// extracted by mini-css-extract-plugin
export var col = "PromoCombined-module--col--aieWJ";
export var container = "PromoCombined-module--container--Yp-Fs";
export var content = "PromoCombined-module--content--zK6sp";
export var contentCta = "PromoCombined-module--content-cta--ENPYC";
export var extendBackgroundColor = "PromoCombined-module--extend-background-color--Fd-jf";
export var featuredImage = "PromoCombined-module--featured-image--rh7M-";
export var row = "PromoCombined-module--row--H7MT1";
export var section = "PromoCombined-module--section--iAERu";